<template>
    <div class="row">
        <div class="col-12 col-md-6">
            <div class="card">
                <div class="card-body">
                    <form @submit.prevent="submit">
                        <div class="form-group">
                            <label for="name">Name*</label>
                            <input class="form-control" id="name" name="name"
                                   placeholder="Enter full name"
                                   type="text"
                                   v-bind:class="[this.name.validated ? this.name.valid ? 'is-valid' : 'is-invalid' : '']"
                                   v-model="form.name"
                                   v-validate="'required'">
                            <div class="invalid-feedback">{{ errors.first('name') }}</div>
                        </div>
                        <div class="form-group">
                            <label for="email">Email*</label>
                            <input class="form-control" id="email" name="email" placeholder="example@example.com"
                                   v-bind:class="[this.email.validated ? this.email.valid ? 'is-valid' : 'is-invalid' : '']"
                                   v-model="form.email"
                                   v-validate="'required|email'">
                            <div class="invalid-feedback">{{ errors.first('email') }}</div>
                        </div>
                        <div class="form-group">
                            <label for="email">Password{{passReq ? '*' : ''}}</label>
                            <input class="form-control" id="password" name="password" placeholder="Enter password"
                                   ref="password"
                                   type="password"
                                   v-bind:class="[this.password.validated ? this.password.valid ? 'is-valid' : 'is-invalid' : '']"
                                   v-model="form.password"
                                   v-validate="(passReq) ? 'required|min:8' : ''">
                            <div class="invalid-feedback">{{ errors.first('password') }}</div>
                        </div>
                        <div class="form-group">
                            <label for="email">Retype password{{passReq ? '*' : ''}}</label>
                            <input class="form-control" data-vv-as="retype password" id="c_password"
                                   name="c_password"
                                   placeholder="Enter same password"
                                   type="password"
                                   v-bind:class="[this.c_password.validated ? this.c_password.valid ? 'is-valid' : 'is-invalid' : '']"
                                   v-model="form.c_password"
                                   v-validate="(form.password) ? 'required|confirmed:password' : ''">
                            <div class="invalid-feedback">{{ errors.first('c_password') }}</div>
                        </div>
                        <div class="form-group">
                            <label for="role">Role</label>
                            <select class="form-control" id="role" v-model="form.roles">
                                <option :key="role"
                                        :value="role"
                                        v-for="role in USER.roles">{{role}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="role">Language</label>
                            <select class="form-control" id="language" v-model="form.language">
                                <option value="nl">NL</option>
                                <option value="en">EN</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="role">Customers</label>
                            <multiselect :clear-on-select="false"
                                         :close-on-select="false"
                                         :hide-selected="true"
                                         :internal-search="false"
                                         :limit="3"
                                         :limit-text="limitText"
                                         :loading="isLoading"
                                         :multiple="true"
                                         :options="countries"
                                         :show-no-results="true"
                                         @search-change="asyncFind"
                                         id="ajax"
                                         label="name"
                                         open-direction="bottom"
                                         placeholder="Type to search"
                                         track-by="id"
                                         v-model="customers"
                                         @select="fitArray"
                                         @remove="fitArrayRemove"
                            />
                        </div>
                        <button class="btn btn-primary mt-3" type="submit">Save</button>
                        <button @click="deleteUser()" class="btn btn-neutral red ml-2" type="button"
                                v-if="!isNew">
                            {{$t('global.Delete')}}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'
    import {mapGetters} from 'vuex'
    import Multiselect from 'vue-multiselect'

    export default {
        name: 'userUpdate',
        data() {
            return {
                isNew: false,
                dispatchLink: 'SAVE_USER',
                id: this.$route.params.id,
                countries: [],
                selectedCountries: [],
                isLoading: false,
                customers: [],
                form: {
                    name: '',
                    email: '',
                    password: '',
                    c_password: '',
                    roles: '',
                    customers: [],
                    language: ''
                }
            }
        },
        components: {
            Multiselect
        },
        computed: {
            ...mapFields(['name', 'email', 'password', 'c_password']),
            ...mapGetters(['USER']),
            //Password validation required only on new and if filled in
            passReq() {
                if (this.isNew || this.form.password) {
                    return true
                } else {
                    return false
                }
            }
        },
        async mounted() {
            //Check create or update
            this.isNew = true;
            this.dispatchLink = 'SAVE_USER';
            if (this.$route.params.id) {
                this.isNew = false;
                this.dispatchLink = 'UPDATE_USER';

                let user = await this.$store.dispatch('GET_USER', this.id)

                //Customers opvullen
                this.customers = user.customers


                //Form opvullen
                this.form = user
                this.form.customers = []

                let app = this
                this.customers.forEach(function(e){
                    app.form.customers.push(e.id)
                })
            }
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //Moet in array voor backend
                        //this.form.roles = [this.form.roles]
                        let form = JSON.parse(JSON.stringify(this.form));
                        if (!form.password) {
                          delete form.password
                        }
                        if (!form.c_password) {
                          delete form.c_password
                        }
                        form.roles = [form.roles];
                        this.$store.dispatch(this.dispatchLink, form)
                            .then(async () => {
                                if (this.isNew) {
                                    //Form leegmaken
                                    this.form = {}
                                    this.$validator.reset()
                                }else{
                                    await this.$store.dispatch('userData')
                                }

                                this.$swal({
                                    title: this.$t('swal.logout.SuccessTitle'),
                                    text: this.$t('swal.logout.SuccessMsg'),
                                    type: "success",
                                    toast: true,
                                    showConfirmButton: false,
                                    position: 'top-end',
                                    timer: 1200
                                });
                            })
                            .catch((error) => {
                                if (error.errors.email) {
                                    this.$validator.errors.add({
                                        field: 'email',
                                        msg: error.errors.email[0]
                                    })
                                    this.fieldsVee.email.valid = false
                                }

                                if (error.errors.password) {
                                    this.$validator.errors.add({
                                        field: 'password',
                                        msg: error.errors.password[0]
                                    })
                                    this.fieldsVee.password.valid = false
                                }
                                if (error.errors.c_password) {
                                    this.$validator.errors.add({
                                        field: 'c_password',
                                        msg: 'The password and retype password must match.'
                                    })
                                    this.fieldsVee.c_password.valid = false
                                }

                            })
                    }
                })
            },
            deleteUser() {
                //Confirmation dialog, are you sure?
                this.$swal({
                    title: this.$t('swal.general.Title'),
                    text: this.$t('swal.delete.Text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: this.$t('swal.general.CancelButtonText'),
                    confirmButtonText: this.$t('swal.delete.ConfirmButtonText')
                }).then(async (result) => {
                        //Sure? -> Delete
                        if (result.value) {

                            let resp = await this.$store.dispatch('DELETE_USER', this.$route.params.id)

                            //Success message
                            this.$swal({
                                title: this.$t('swal.delete.SuccessTitle'),
                                text: resp.message,
                                type: "success",
                                toast: true,
                                showConfirmButton: false,
                                position: 'top-end',
                                timer: 1200
                            });

                            //Terugsturen naar index
                            this.$router.push({name: 'measurementIndex'})
                        }
                    }
                )
            },
            limitText(count) {
                return `and ${count} other countries`
            },
            async asyncFind(query) {
                this.isLoading = true
                await this.$store.dispatch('DROPDOWN_CUSTOMER', query).then((res) => {
                    this.countries = res
                    this.isLoading = false
                })
            },
            fitArray(obj){
                this.form.customers.push(obj.id)
            },
            fitArrayRemove(obj){
                let app = this
                this.form.customers.forEach(function(e, index){
                    if(e == obj.id){
                        app.form.customers.splice(index)
                    }
                })
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
